import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const TTL_MS = 300_000; // 5 minuten

interface CacheEntry {
  data: any[];
  timestamp: number;
}

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache = new Map<string, CacheEntry>();
  public cache$ = new BehaviorSubject<any[]>(null);

  set(key: string, data: any[]): void {
    this.cache.set(key, { data, timestamp: Date.now() });
    this.cache$.next(data);
  }

  get(key: string): any[] | null {
    const entry = this.cache.get(key);
    if (!entry) return null;
    if (Date.now() - entry.timestamp > TTL_MS) {
      this.cache.delete(key);
      return null;
    }
    return entry.data;
  }

  clear(key: string): void {
    this.cache.delete(key);
    this.cache$.next(null);
  }
}
